import { gql } from '@apollo/client';
export const CreateMutation = `
 mutation CreateTask($input: CreateTaskInput!) { 

  createTask(input: $input) { 

    success 

    error 

    message 

  } 

} 
`;

export const Updatemutation = `
 mutation UpdateTask($input: UpdateTaskInput!) { 

  updateTask(input: $input) { 

    success 

    error 

    message 

    data { 

      id 

      title 

      attachment 

    } 

  } 

} 
`;

export const GetByIDData = `
query GetTaskById($id: Int!) { 

  taskById(id: $id) { 
    success 
    message 
    data { 

      id 

      title 

      module 

      description 

      priority 

      status 

      requestedDate 

      startDate 

      endDate 

      deadlineDate 

      customer { 

        legalName 

      } 

      lead { 

        firstName 

      } 

      assignedTo { 

        username 

      } 

    } 

  } 

} `;

export const DeleteMutation = `mutation DeleteTask($id: ID!) { 

  deleteTask(id: $id) { 

    success 

    error 

    message 

  } 

} ` 

export const AllqueryData = `query { 

  allTasks { 

    success 

    message 

    data { 

      id 

      title 

      description 

      module 

      priority 

      status 

      requestedDate 

      startDate 

      endDate 

      deadlineDate 

      customer { 

        id 

        legalName 

      } 

      lead { 

        id 

        firstName 

      } 

      assignedTo { 

        id 

        username 

      } 

    } 

  } 

} `

export const allLeadprospectquery = `
   query {
    allLeadprospect {
      id
      prsid
      companyName
      mailId
      contactNumber
      leadSource
      addressLine1
      nextFollowUpdate
      createdAt
      user {
        username
      }
    }
  }
`;

export const AllCustomerDetailsQuery = `
query {
    allCustomer {
      id
      cusid
      legalName
      customerCategory
      pan
      address1Line1
      address2Line1
      createdAt
      user {
        username
      }
    }
  }
`;